import { useEffect } from 'react';

const useUnsavedWarning = (isDirty) => {
  useEffect(() => {
    const handler = (e) => { if (isDirty) { e.preventDefault(); e.returnValue = ''; } };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
};

export default useUnsavedWarning;
